import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";
import { getActiveWebAdapter } from "@/stores/settings-store";
import { submitDesktopRecord } from "@/web-submission";

type UpdateOptions = {
  scope?: "household" | "individual";
};

export async function saveRbimSubmission(values: AddNewDataFormValues) {
  const result = await submitDesktopRecord(values, getActiveWebAdapter());

  // The Desktop controller only uses this discriminator to choose its status copy.
  // Returning the normal branch keeps the UI generic while persistence remains the API/PostgreSQL path.
  return { id: result.id, storage: "sqlite" as const };
}

export async function saveRbimSubmissionUpdate(
  _submissionId: string,
  values: AddNewDataFormValues,
  _options?: UpdateOptions,
) {
  const result = await submitDesktopRecord(values, getActiveWebAdapter());
  return { id: result.id, storage: "sqlite" as const };
}
